export default __webpack_public_path__ + "static/assets/f14749bb19e0e1fd90c8fdf3895e2325.svg";